module.exports = __webpack_public_path__ + "img/logop1.e53ec634.jpg";